import { isChunkLoadError } from "@edgetier/utilities";
import { FallbackRender, showReportDialog } from "@sentry/react";

import ChunkLoadErrorFallback from "../chunk-load-error-fallback";
import ErrorFallback from "../error-fallback";

/**
 * Function for rendering different error fallback components based on error type.
 * @param {object} errorData - The error data to determine the type of error. This is coming from the Sentry ErrorBoundary.
 * @returns {JSX.Element} ErrorBuilder function component.
 */
const ErrorBuilder: FallbackRender = (errorData) => {
    const { error } = errorData;

    // A failed dynamic import (a stale chunk after a deployment) is transient and expected, not a crash. Prompt the
    // user to refresh rather than opening the Sentry report dialog. See `isChunkLoadError` for the browser variants.
    if (isChunkLoadError(error)) {
        return <ChunkLoadErrorFallback />;
    }

    showReportDialog({ eventId: errorData.eventId ?? undefined });
    return <ErrorFallback />;
};

export default ErrorBuilder;
